<template>
    <v-layout justify-center>
        <v-responsive max-width="1024px" width="100%" class="shop-coupon-view">
            <v-row class="mt-8" justify="center" align="center">
                <v-col cols="auto" class="pt-0 pb-0 headline text-start">
                    <span v-if="$route.params._coupon === undefined">쿠폰 등록</span>
                    <span v-else>쿠폰 정보</span>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>

            <v-tabs v-model="tabIndex" background-color="content" class="mt-4">
                <v-tab href="#firstPurchaseCoupon" :disabled="!!$route.params._coupon">첫구매고객</v-tab>
                <v-tab href="#repurchaseCoupon" :disabled="!!$route.params._coupon">재구매고객</v-tab>
                <v-tab href="#targetingCoupon" :disabled="!!$route.params._coupon">타겟팅</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tabIndex">
                <v-tab-item value="firstPurchaseCoupon">
                    <first-purchase-coupon v-model="firstPurchaseCoupon" :categories="categories"></first-purchase-coupon>
                </v-tab-item>
                <v-tab-item value="repurchaseCoupon">
                    <repurchase-coupon v-model="repurchaseCoupon" :categories="categories"></repurchase-coupon>
                </v-tab-item>
                <v-tab-item value="targetingCoupon">
                    <targeting-coupon v-model="targetingCoupon" :categories="categories"></targeting-coupon>
                </v-tab-item>
            </v-tabs-items>


            <v-row justify="center" class="mt-4">
                <v-col cols="auto">
                    <v-btn color="primary" @click="save" :disabled="!!$route.params._coupon">저장</v-btn>
                </v-col>
            </v-row>

        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";

import FirstPurchaseCoupon from "@/components/console/shop/coupons/first-purchase-coupon.vue";
import RepurchaseCoupon from "@/components/console/shop/coupons/repurchase-coupon.vue";
import TargetingCoupon from "@/components/console/shop/coupons/targeting-coupon.vue";

export default {
    components: {
        FirstPurchaseCoupon,
        RepurchaseCoupon,
        TargetingCoupon,
    },
    data() {
        return {
            tabIndex: "firstPurchaseCoupon",

            categories: null,

            firstPurchaseCoupon: null,
            repurchaseCoupon: null,
            targetingCoupon: null,
        };
    },

    mounted(){
        this.init();
    },

    methods: {
        async init(){
            try{
                var { categories } = await api.console.shop.categories.getCategories();
                this.categories = categories;

                if(this.$route.params._coupon){
                    var { coupon } = await api.console.shop.coupons.getCoupon({
                        _id: this.$route.params._coupon
                    });

                    switch(coupon.kind){
                        case "firstPurchaseCoupon": {
                            this.firstPurchaseCoupon = coupon;
                            this.tabIndex = coupon.kind;
                            break;
                        }
                        case "repurchaseCoupon": {
                            this.repurchaseCoupon = coupon;
                            this.tabIndex = coupon.kind;
                            break;
                        }
                        case "targetingCoupon": {
                            this.targetingCoupon = coupon;
                            this.tabIndex = coupon.kind;
                            break;
                        }
                    }
                }
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        check(coupon){
            try{
                if(!coupon.name) throw new Error("쿠폰명을 입력해주세요");
                if(!coupon.amount || coupon.amount < 0) throw new Error("할인금액을 입력해주세요");
                
                if(coupon.download.period && !coupon.download.startDate) throw new Error("혜택기간 시작일자를 입력해주세요");
                if(coupon.expiration.enabled){
                    switch(coupon.expiration.type){
                        case "period": {
                            if(!coupon.expiration.startDate || !coupon.expiration.endDate) throw new Error("쿠폰유효기간을 설정해주세요");
                            break;
                        }
                        case "days": {
                            if(!coupon.expiration.days || coupon.expiration.days < 0) throw new Error("쿠폰유효기간을 설정해주세요");
                            break;
                        }
                    }
                }
                return true;
            }
            catch(error){
                console.error(error);
                alert(error.message);
            }
            return false;
        },
        async save(){
            try{
                var coupon;
                switch(this.tabIndex){
                    case "firstPurchaseCoupon": coupon = this.firstPurchaseCoupon; break;
                    case "repurchaseCoupon": coupon = this.repurchaseCoupon; break;
                    case "targetingCoupon": coupon = this.targetingCoupon; break;
                }

                if(this.check(coupon)){
                    await api.console.shop.coupons.postCoupon(coupon);

                    alert("저장되었습니다");
                    this.$router.go(-1);
                }
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        
    },
}
</script>

<style>
.shop-coupon-view .weight input { text-align: end; }
.shop-coupon-view .amount input { text-align: end; }
.shop-coupon-view .birth input { text-align: center; }
.shop-coupon-view .theme--light.v-tabs-items { background-color: transparent !important; }
</style>
